<div class="ids-card -no-border color-card ids-p-6">
  <p class="ids-mb-4 ids-label -bold">acompanhe a divisão do imóvel</p>

  <ids-progress-bar
    [fill]="totalSelectedPercent > totalPercent ? 100 : totalSelectedPercent"
    [ngClass]="totalSelectedPercent > totalPercent ? 'error-progress' : ''">
  </ids-progress-bar>


  <div class="ids-d-flex between align-center">
    <p class="ids-label">{{ totalSelectedPercent | number: '1.0-2' }}% dividido</p>
    <p class="ids-label">{{ remainingPercent | number: '1.0-2' }}% restante</p>
  </div>

  <div class="error-container" *ngIf="totalSelectedPercent > totalPercent">
    <hr aria-hidden="true" class="ids-divider -soft ids-mb-4 ids-mt-4" />
    <div class="ids-d-flex gap-2 align-center">
      <ids-icon variant="error">warning_base</ids-icon>
      <p class="ids-label -error">você ultrapassou o limite da porcentagem total de 100%</p>
    </div>
  </div>
</div>
